import React from 'react';

function Loading() {
  return (
    <div className="Loading">
      <ul className="Loading_list">
        <li className="Loading_item" />
        <li className="Loading_item" />
        <li className="Loading_item" />
      </ul>
    </div>
  );
}

export default Loading;
